<template>
  <div class="modal fade" id="add-device" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            id="device-add-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="row g-6">
            <div class="col-sm-12">
              <label class="form-label" for="">{{ $t("nases.name") }}</label>
              <input
                type="text"
                v-model="nas.name"
                class="form-control"
                :placeholder="$t('nases.name')"
              />
            </div>
            <div>
              <h5 class="card-header">{{ $t("nases.connection") }}</h5>
              <hr class="m-0" />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{ $t("nases.ip") }}</label>
              <input
                type="text"
                v-model="nas.ip"
                class="form-control"
                placeholder="x.x.x.x"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">Radius Secret</label>
              <input
                type="text"
                v-model="nas.radius_secret"
                class="form-control"
                placeholder="testing1234"
              />
            </div>
            <div>
              <h5 class="card-header">{{ $t("nases.login") }}</h5>
              <hr class="m-0" />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("nases.api_username")
              }}</label>
              <input
                type="text"
                v-model="nas.api_username"
                class="form-control"
                :placeholder="$t('nases.api_username')"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("nases.api_password")
              }}</label>
              <input
                type="text"
                v-model="nas.api_password"
                class="form-control"
                :placeholder="$t('nases.api_password')"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("nases.api_port")
              }}</label>
              <input
                type="text"
                v-model="nas.api_port"
                class="form-control"
                placeholder="8728"
              />
            </div>
            <div>
              <h5 class="card-header">{{ $t("nases.other") }}</h5>
              <hr class="m-0" />
            </div>
            <div class="col-sm-6">
              <label class="form-label">{{ $t("nases.version") }}</label>
              <select
                v-model="nas.legacy"
                class="form-select w-100"
                data-style="btn-default"
              >
                <option value="0">v3.36 and up</option>
                <option value="1">v3.34 and down</option>
              </select>
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">SNMP Community</label>
              <input
                type="text"
                v-model="nas.snmp_community"
                class="form-control"
                id="basic-url3"
                aria-describedby="basic-addon34"
                placeholder="public"
              />
            </div>
            <div v-if="settings.features.wa" class="col-sm-6">
              <label class="form-label" for="">{{
                $t("nases.wa_instance")
              }}</label>
              <input
                type="text"
                v-model="nas.wa_instance"
                class="form-control"
                aria-describedby="wa_instance"
                placeholder="xxxxxxxx-xxxx-xxxx-xxxxxxxxxxxx"
              />
            </div>
            <div v-if="settings.features.wa" class="col-sm-6">
              <label class="form-label" for="">{{
                $t("nases.whatsapp_network_name")
              }}</label>
              <input
                type="text"
                v-model="nas.wa_name"
                class="form-control"
                aria-describedby="wa_name"
                :placeholder="$t('nases.whatsapp_network_name')"
              />
            </div>
            <div>
              <h5 class="card-header">{{ $t("nases.privileges") }}</h5>
              <hr class="m-0" />
            </div>
            <div class="col-12">
              <!-- <label for="flatpickr-datetime" class="form-label">{{
                $t("nases.allowed_profiles")
              }}</label>

              <div class="select2-primary" style="max-height: 200px;">
                <multiselect
                  v-model="this.nas.allowed_profiles"
                  :options="profiles"
                  :close-on-select="false"
                  :trackBy="'value'"
                  :label="'label'"
                  :searchable="false"
                  :taggable="true"
                  :multiple="true"
                  :hideSelected="true"
                ></multiselect>
              </div> -->
              <h5 class="card-header">
                <div class="d-inline-block">
                  <input
                    type="checkbox"
                    @input="checkAll(profiles, nas.allowed_profiles)"
                    v-model="nas.allowed_profiles.checkAll"
                    class="form-check-input"
                  />
                </div>
                <label for=""
                  ><h4 class="mx-1">
                    {{ $t("nases.allowed_profiles") }}
                  </h4></label
                >
              </h5>
              <hr class="m-0" />
              <div class="row g-2 mt-1">
                <div
                  class="col-3"
                  v-for="(profile, index) in profiles"
                  :key="index"
                  v-memo="[nas.allowed_profiles.length]"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :name="profile.value"
                    :id="profile.value"
                    :value="profile"
                    v-model="nas.allowed_profiles"
                  />
                  <label :for="profile.value">{{ profile.label }}</label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <!-- <label for="flatpickr-datetime" class="form-label">{{
                $t("nases.allowed_admins")
              }}</label>

              <div class="select2-primary">
                <multiselect
                  v-model="this.nas.allowed_users"
                  :options="users"
                  :close-on-select="false"
                  :trackBy="'value'"
                  :label="'label'"
                  :searchable="false"
                  :taggable="true"
                  :multiple="true"
                  :hideSelected="true"
                ></multiselect>
              </div> -->

              <h5 class="card-header">
                <div class="d-inline-block">
                  <input
                    type="checkbox"
                    @input="checkAll(users, nas.allowed_users)"
                    v-model="nas.allowed_users.checkAll"
                    class="form-check-input"
                  />
                </div>
                <label for=""
                  ><h4 class="mx-1">
                    {{ $t("nases.allowed_admins") }}
                  </h4></label
                >
              </h5>
              <hr class="m-0" />
              <div class="row g-2 mt-1">
                <div
                  class="col-3"
                  v-for="(user, index) in users"
                  :key="index"
                  v-memo="[nas.allowed_users.length]"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :name="user.value"
                    :id="user.value"
                    :value="user"
                    v-model="nas.allowed_users"
                  />
                  <label :for="user.value">{{ user.label }}</label>
                </div>
              </div>
            </div>
            <div v-if="error_message" class="col-span-2 text-red-500">
              {{ error_message }}
            </div>

            <div class="col-12 d-flex justify-content-end">
              <button @click.prevent="store" class="btn btn-success">
                {{ this.nas.id ? $t("nases.save") : $t("nases.add") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "deviceAdd",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      nas: {
        ip: "",
        name: "",
        radius_secret: "ssradius1234",
        api_username: "",
        api_password: "",
        api_port: "8728",
        snmp_community: "public",
        legacy: "0",
        description: "",
        wa_instance: null,
        wa_name: null,
        allowed_profiles: [],
        allowed_users: [],
      },
      profiles: [],
      users: [],
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.fetchProfiles();
    await this.fetchUsers();
    if (this.$route.query.nas_id) {
      await this.fetchNas(this.$route.query.nas_id);
    } else {
      var temp = [];
      this.profiles.forEach((element) => {
        temp.push(element);
      });
      this.nas.allowed_profiles = temp;
      this.nas.allowed_profiles.checkAll = true;
      temp = [];
      this.users.forEach((element) => {
        temp.push(element);
      });
      this.nas.allowed_users = temp;
      this.nas.allowed_users.checkAll = true;
    }
    if (this.$route.query.operation == "copy") {
      this.nas.id = null;
      this.nas.name = "";
      this.nas.ip = "";
    }
    this.loading = false;
  },
  methods: {
    async fetchNas(id) {
      const response = await axios.get(`nases/${id}`);
      if (response.status == 200) {
        this.nas = response.data.data;
        var temp = [];
        this.nas.allowed_profiles.forEach((element) => {
          temp.push({ value: element.id, label: element.name });
        });
        this.nas.allowed_profiles = temp;
        temp = [];
        this.nas.allowed_users.forEach((element) => {
          temp.push({ value: element.id, label: element.email });
        });
        this.nas.allowed_users = temp;
      }
    },
    async fetchProfiles() {
      const response = await axios.get("profiles?rows=10000000");
      response.data.data.forEach((element) => {
        this.profiles.push({ value: element.id, label: element.name });
      });
    },
    async fetchUsers() {
      const response = await axios.get("admins?rows=10000000");
      response.data.data.forEach((element) => {
        this.users.push({ value: element.id, label: element.email });
      });
    },
    checkAll(data, model) {
      if (!model.checkAll) {
        data.forEach((element) => {
          model.push(element);
        });
      } else {
        model.splice(0, model.length);
      }
    },
    async store() {
      var temp = [];
      this.nas.allowed_profiles.forEach((profile) => {
        temp.push(profile.value);
      });
      this.nas.allowed_profiles = temp;
      temp = [];
      this.nas.allowed_users.forEach((user) => {
        temp.push(user.value);
      });
      this.nas.allowed_users = temp;
      if (this.nas.id) {
        this.nas.allowed_users = temp;
        const response = await axios.put(`/nases/${this.nas.id}`, this.nas);
        if (response.status == 200) {
          document.getElementById("device-add-close").click();
          this.$notify({
            text: "Network Updated Successfully",
            type: "success",
          });
          this.$emit("updated");
        }
      } else {
        const response = await axios.post("nases", this.nas);
        if (response.status == 200) {
          document.getElementById("device-add-close").click();
          this.$notify({
            text: "Network Added Successfully",
            type: "success",
          });
          this.$emit("updated");
        } else if (response.status == 210) {
          this.validated = false;
          this.error_message = this.$t("errors.license.license_nases_exceeded");
        }
      }
    },
  },
};
</script>
